export default "__VITE_PUBLIC_ASSET__f39ae40d__"